<template>
  <div>

    <div id="alumniList">
      <div v-for="(continent, index) in continents" :key="index">
        <div v-if="index != 'Antarctica' || continent['Antarctica']['tj'].length || continent['Antarctica']['jk'].length">

          <a href="#" @click.prevent="showContinent(index)" class="link-continent">
            <div class="container">
              <h2 class="heading-continent" :class="{ 'open' : openContinent == index }">{{index}}</h2>
            </div>
          </a>
          <div class="countries-wrapper" :class="{ 'open' : openContinent == index }">
            <div v-for="country in continent" :key="country.name">
              <template v-if="country.tj.length || country.jk.length">
                <div :id="country.id" class="country-wrapper" :class="{ 'open' : openCountry.includes(country.name) }">
                  <a href="#" @click.prevent="showCountry(country.name)" class="link-country">
                    <div class="container">
                      <div class="d-flex">
                        <h3 class="heading-country">
                          <span v-if="country.emoji.length">{{country.emoji}}</span> 
                          {{ country.name }} (<span v-html="country.tj.length + country.jk.length"></span>)
                        </h3>
                        <span class="open-indicator" :class="{ 'open' : openCountry.includes(country.name) }">+</span>
                      </div>
                    </div>  
                  </a>
                </div>
                <div class="list-fellows-wrapper" :class="{ 'open' : openCountry.includes(country.name) }">
                  <div class="container">
                    <a href="#" @click.prevent="showMap" class="btn btn-view-toggle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M7 5.5c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5v16c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5v-16zm8 5c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5V.5c0-.27614237.2238576-.5.5-.5s.5.22385763.5.5v10zM7.49999031 20.8855413l5.70937779-4.0783989c.2247012-.1605116.5369779-.1084756.6974895.1162257.1605116.2247012.1084756.5369779-.1162257.6974895l-5.99999997 4.286c-.17384956.1241865-.40739755.1241902-.58125103.0000091l-7-5C.07798284 16.813011 0 16.6614756 0 16.5V.5C0 .09331372.45968486-.14324833.7906191.09313326L7.5 4.8855482 14.2093809.09313326c.1738488-.12417768.4073894-.12417768.5812382 0l7 5C21.9220172 5.18698902 22 5.33852445 22 5.5v5c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5V5.75730895L14.5 1.1144518 7.7906191 5.90686674c-.17384876.12417768-.40738944.12417768-.5812382 0L1 1.47159466V16.2426911l6.49999031 4.6428502z"/>
                        <path d="M19.7298535 22.410526c.4626931-.5967776.9253539-1.2275809 1.3563917-1.8628768.3161119-.4659093.6030907-.916805.8540592-1.3459888C22.6214635 18.0368031 23 17.0909932 23 16.5c0-1.9328576-1.5671424-3.5-3.5-3.5-1.9334929 0-3.5 1.5667776-3.5 3.5 0 .5909932.3785365 1.5368031 1.0596956 2.7016604.2509685.4291838.5379473.8800795.8540592 1.3459888.4310378.6352959.8936986 1.2660992 1.3563917 1.8628768.0823909.1062672.1592832.2044439.2298535.2937687.0705703-.0893248.1474626-.1875015.2298535-.2937687zM24 16.5c0 .8207223-.4307758 1.8970571-1.1964523 3.2064484-.2630218.4497965-.5618093.9192456-.8897929 1.4026524-.4439622.6543447-.9188014 1.3017524-1.3936083 1.9141544-.1662019.2143658-.3206346.4091782-.4594125.5808737-.0837463.1036107-.1440169.1769093-.176919.2163178-.1998785.2394044-.5677515.2394044-.76763 0-.0329021-.0394085-.0931727-.1127071-.176919-.2163178-.1387779-.1716955-.2932106-.3665079-.4594125-.5808737-.4748069-.612402-.9496461-1.2598097-1.3936083-1.9141544-.3279836-.4834068-.6267711-.9528559-.8897929-1.4026524C15.4307758 18.3970571 15 17.3207223 15 16.5c0-2.4854685 2.0141837-4.5 4.5-4.5 2.4851424 0 4.5 2.0148576 4.5 4.5z"/>
                        <path d="M19.5 18.5c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2zm0-1c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1-1 .4477153-1 1 .4477153 1 1 1z"/>
                      </svg>
                    </a>
                    <h4 class="fellows-heading">
                      <small>
                        <span class="font-heavy">{{ country.tj.length }}</span> THOMAS J. WATSON FELLOW<span v-if="country.tj.length != 1">S</span></span>
                      </small>
                      <small v-if="country.jk.length > 0">
                        <span class="font-heavy">{{ country.jk.length }}</span> JEANNETTE K. WATSON FELLOW<span v-if="country.jk.length != 1">S</span></span>
                      </small>  
                    </h4>

                    <template v-if="country.jk.length">
                      <h4 class="heading-fellow-type">
                        JEANNETTE K. WATSON FELLOW<span v-if="country.jk.length != 1">S</span>
                      </h4>	
                      <ul class="list-unstyled list-fellows">				
                        <li v-for="fellow in alumniByCountry(country, 'jk')" :key="fellow.Id" class="fellow">
                          <router-link :to="'/WAT50N/map/list/'+fellow.Id">
                            <h5>{{ fellow.FullName__c }}</h5>
                            {{ fellow.Account.Name }}<br>
                            <h4><small>{{ fellow.Master_Year__r.Year__c }}</small></h4>
                          </router-link>
                        </li>					
                      </ul>
                    </template>

                    <template v-if="country.tj.length">
                      <h4 class="heading-fellow-type">
                        THOMAS J. WATSON FELLOW<span v-if="country.tj.length != 1">S</span>
                      </h4>	
                      <ul class="list-unstyled list-fellows">				
                        <li v-for="fellow in alumniByCountry(country, 'tj')" :key="fellow.Id" class="fellow">

                          <router-link :to="'/WAT50N/map/list/'+fellow.Id">
                            <h5>{{ fellow.FullName__c }}</h5>
                            {{ fellow.Account.Name }}<br>
                            <h4><small>{{ fellow.Master_Year__r.Year__c }}</small></h4>
                          </router-link>
                        </li>					
                      </ul>
                    </template>

                  </div>  
                </div>  
              </template>
            </div>
          </div>
        </div>
      </div>

    </div>
    <router-view :continents="continents" :filter="filter"></router-view>
  </div>
</template>

<script>

export default {
  props: ['continents', 'filter', 'loading'],
  data(){
    return{
      openContinent: null,
      openCountry: []
    }
  },

  methods: {

    alumniByCountry(country, type) {
      let alumni = []
      if (type == 'tj') {
        country.tj.forEach(fellow => {
          alumni.push(fellow)
        })
      } else {
        country.jk.forEach(fellow => {
          alumni.push(fellow)
        })
      }

      return alumni
    },

    showContinent(continent) {
      if (this.openContinent == continent) {
        this.openContinent = null
      } else {
        this.openContinent = continent
      }
    },
    showCountry(country) {
      if (this.openCountry.includes(country)) {
        // this.openCountry = null
        const index = this.openCountry.indexOf(country);
        if (index > -1) {
          this.openCountry.splice(index, 1);
        }
      } else {
        this.openCountry.push(country)
      }
    }
  },

  mounted() {
    if (this.$route.query.continent && this.$route.query.country && this.$route.query.markerId) {
      this.openContinent = this.$route.query.continent
      this.openCountry.push(this.$route.query.country)
      this.$nextTick(function () {
        this.$scrollTo('#' + this.$route.query.markerId)
      })
    }

  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// scripts/alumni-list.vue